import { useQuery } from "@tanstack/react-query";
import DataService from "../services/DataService";

export default function useProvider() {
    const {
        data: provider = {},
    } = useQuery({ queryKey: ['provider'], queryFn: DataService.getProvider, refetchOnWindowFocus: false })
    return provider
}